import ClientDetailTabDemand from '@/components/client/demand/DetailTabDemand.vue'
import ClientInnerTabDemandActives from '@/components/client/demand/InnerTabDemandActives.vue'
import ClientInnerTabDemandCompleteds from '@/components/client/demand/InnerTabDemandCompleteds.vue'
import ClientInnerTabDemandStandby from '@/components/client/demand/InnerTabDemandStandby.vue'
import demandModalRouter from '@/router/routers/demandModal'

const demandRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    const requesterType = basePath.replace('/', '')
    const activesDetailTo = `DetalheDemanda${singleName}Ativas`
    const completedsDetailTo = `DetalheDemanda${singleName}Finalizadas`
    const standbyDetailTo = `DetalheDemanda${singleName}StandyBy`

    return {
        beforeEnter: beforeEnter,
        name: '',
        path: `${basePath}/detalhe/:id/demandas/ativas`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default'
        },
        props: true,
        component: ClientDetailTabDemand,
        children: [
            {
                beforeEnter: beforeEnter,
                name: `${singleName}AbaInternaDemandasAtivas`,
                path: '',
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    name: name.toLowerCase(),
                    singleName: singleName,
                    basePath: basePath,
                    tabs,
                    detailTo: activesDetailTo,
                    requesterType
                },
                props: true,
                component: ClientInnerTabDemandActives,
                children: [
                    demandModalRouter(beforeEnter, `CadastrarDemanda${singleName}AA`, `:requesterType/detalhe/:requesterId?/demandas`, false, singleName, requesterType),
                    demandModalRouter(beforeEnter, `DetalheDemanda${singleName}Ativas`, `:requesterType/detalhe/:requesterId?/demandas/ativas`, true, singleName, requesterType)
                ]
            },
            {
                beforeEnter: beforeEnter,
                name: `${singleName}AbaInternaDemandasFinalizadas`,
                path: `${basePath}/detalhe/:id/demandas/finalizadas`,
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    name: name.toLowerCase(),
                    singleName: singleName,
                    basePath: basePath,
                    tabs,
                    detailTo: completedsDetailTo,
                    requesterType
                },
                props: true,
                component: ClientInnerTabDemandCompleteds,
                children: [
                    demandModalRouter(beforeEnter, `CadastrarDemanda${singleName}BB`, `:requesterType/detalhe/:requesterId?/demandas`, false, singleName, requesterType),
                    demandModalRouter(beforeEnter, `DetalheDemanda${singleName}Finalizadas`, `:requesterType/detalhe/:requesterId?/demandas/finalizadas`, true, singleName, requesterType)
                ]
            },
            {
                beforeEnter: beforeEnter,
                name: `${singleName}AbaInternaDemandasStandby`,
                path: `${basePath}/detalhe/:id/demandas/standby`,
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    name: name.toLowerCase(),
                    singleName: singleName,
                    basePath: basePath,
                    tabs,
                    detailTo: standbyDetailTo,
                    requesterType
                },
                props: true,
                component: ClientInnerTabDemandStandby,
                children: [
                    demandModalRouter(beforeEnter, `CadastrarDemanda${singleName}CC`, `:requesterType/detalhe/:requesterId?/demandas`, false, singleName, requesterType),
                    demandModalRouter(beforeEnter, `DetalheDemanda${singleName}StandyBy`, `:requesterType/detalhe/:requesterId?/demandas/standby`, true, singleName, requesterType)
                ]
            }
        ]
    }
}

export default demandRouter
